<template>
  <b-row>
    <b-col
      v-for="stat in stats"
      :key="stat.title"
      sm="6"
      lg="3"
      class="mb-3"
    >
      <b-card
        no-body
        class="shadow-sm h-100"
      >
        <b-card-body class="d-flex align-items-center">
          <div
            class="rounded-circle d-flex align-items-center justify-content-center mr-3"
            :class="stat.iconBg"
            style="width: 48px; height: 48px; min-width: 48px"
          >
            <feather-icon
              :icon="stat.icon"
              size="22"
              :class="stat.iconColor"
            />
          </div>
          <div>
            <h3 class="mb-0 font-weight-bolder">
              {{ stat.value }}
            </h3>
            <small class="text-muted">{{ stat.title }}</small>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
} from 'bootstrap-vue'
import agendamentosService from '@/services/agendamentos'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
  },
  data() {
    return {
      estatisticas: null,
    }
  },
  computed: {
    stats() {
      const hoje = this.estatisticas?.hoje || {}
      return [
        {
          title: 'Agendamentos Hoje',
          value: hoje.total ?? 0,
          icon: 'CalendarIcon',
          iconBg: 'bg-light-primary',
          iconColor: 'text-primary',
        },
        {
          title: 'Pendentes',
          value: hoje.pendentes ?? 0,
          icon: 'ClockIcon',
          iconBg: 'bg-light-warning',
          iconColor: 'text-warning',
        },
        {
          title: 'Concluídos',
          value: hoje.concluidos ?? 0,
          icon: 'CheckCircleIcon',
          iconBg: 'bg-light-success',
          iconColor: 'text-success',
        },
        {
          title: 'Agendados',
          value: hoje.agendados ?? 0,
          icon: 'CalendarIcon',
          iconBg: 'bg-light-info',
          iconColor: 'text-info',
        },
      ]
    },
  },
  async created() {
    await this.carregarEstatisticas()
  },
  methods: {
    async carregarEstatisticas() {
      try {
        const atendenteId = localStorage.getItem('executivo_id')
        const params = atendenteId ? { atendente_id: atendenteId } : {}
        const response = await agendamentosService.buscarEstatisticasAgendamentos(params)
        this.estatisticas = response?.data || response || {}
      } catch (error) {
        // console.error('Erro ao carregar estatísticas:', error)
      }
    },
  },
}
</script>
